/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { withTheme } from '@emotion/react';
//
import * as React from 'react';
import compose from 'utils/compose';

import Checkbox from '@mui/material/Checkbox';
import { withStyles } from 'tss-react/mui';

const styles = () => ({});

export const fieldToCheckbox = ({ field, form: { isSubmitting }, disabled = false, ...props }) => ({
  disabled: disabled || isSubmitting,
  ...props,
  ...field,

  checked: field.value ? 'checked' : '',
  value: field.value ? 'checked' : '',
});

const FormikCheckbox = (props) => {
  const { field, form, onChange, ...other } = props;
  const { setFieldValue } = form;
  const { name } = field;

  const handleChange = (event, checked) => {
    setFieldValue(name, checked);

    if (onChange) {
      onChange(event, checked);
    }
  };

  return <Checkbox onChange={handleChange} checked={!!field.value} {...other} />;
};

FormikCheckbox.displayName = 'FormikCheckbox';

export default compose(withTheme)(withStyles(FormikCheckbox, styles));
